import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tbdc-scenariostatus" }
const _hoisted_2 = {
  key: 0,
  class: "tbdc-scenariostatusnumber",
  style: {"background-color":"forestgreen","color":"white"}
}
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = {
  key: 1,
  class: "tbdc-scenariostatusnumber",
  style: {"background-color":"darkorange","color":"white"}
}
const _hoisted_5 = { style: {"text-align":"center"} }
const _hoisted_6 = {
  key: 2,
  class: "tbdc-scenariostatusnumber",
  style: {"background-color":"#eeeeee","color":"black"}
}
const _hoisted_7 = { style: {"text-align":"center"} }
const _hoisted_8 = {
  key: 3,
  class: "tbdc-scenariostatusnumber",
  style: {"background-color":"red","color":"black"}
}
const _hoisted_9 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_icon, null, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("mdi-map-marker-multiple-outline", -1)
      ]))]),
      _: 1
    }),
    (_ctx.status == 9)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.scenario.parentScenarioId == null ? '0' : _ctx.changes), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.status < 9 && _ctx.status > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.scenario.parentScenarioId == null ? '0' : _ctx.changes), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.status == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.scenario.parentScenarioId == null ? '0' : _ctx.changes), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.status == 10)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.scenario.parentScenarioId == null ? '0' : _ctx.changes), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.status > 0 && _ctx.status < 9)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 4,
          "background-color": "green",
          "buffer-value": Math.round(100 / 8 * (_ctx.status - 1)),
          style: {"position":"absolute","bottom":"-8px"},
          indeterminate: "",
          color: "yellow darken-2"
        }, null, 8, ["buffer-value"]))
      : _createCommentVNode("", true)
  ]))
}